import { useSuspenseQuery } from "@apollo/client/react";

import {
  GetUserForUpdateDocument,
  type GetUserForUpdateQuery,
  type GetUserForUpdateQueryVariables,
} from "~/features/admin/users/gqls";

export function useUserForUpdate(id: string) {
  return useSuspenseQuery<GetUserForUpdateQuery, GetUserForUpdateQueryVariables>(GetUserForUpdateDocument, {
    variables: { id },
  });
}
